import { EventEmitter } from '@angular/core';
import { CommonService } from "../common.service";
import { ApiService } from "../api.service";
import { ActivatedRoute, Router } from "@angular/router";
var CasePracticeTeamBeginComponent = (function () {
    function CasePracticeTeamBeginComponent(commonService, apiService, route, router) {
        this.commonService = commonService;
        this.apiService = apiService;
        this.route = route;
        this.router = router;
        this.onGoToMain = new EventEmitter();
        this.onGoToVideo = new EventEmitter();
        this.assetsRoute = "../../assets";
        this.flag = false;
    }
    CasePracticeTeamBeginComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
        var that = this;
        this.route.queryParams.subscribe(function (queryParams) {
            _this.type = queryParams['type'];
        });
        this.route.params.subscribe(function (params) {
            _this.multiExerciseMetaId = params['multiExerciseMetaId'];
            _this.learningPathId = params['learningPathId'];
            _this.practiceMetaId = params['practiceMetaId'];
            _this.apiService.ajax({
                'type': 'get',
                'url': '/api/getExercise/' + _this.multiExerciseMetaId
            }).subscribe(function (result) {
                _this.exercises = result;
                var temp = true;
                _this.exercises.forEach(function (item, index) {
                    if (item.status != 2) {
                        temp = false;
                    }
                });
                _this.exercises.filter(function (item) {
                    if (item.status === 2) {
                        _this.flag = true;
                    }
                });
                _this.completed = temp;
                console.log(_this.flag);
                if (!_this.flag) {
                    var exerciseMetaId = $('#exerciseMetaId').val();
                    _this.apiService.learingTime({ learningPathMetaId: localStorage.getItem("learningPathMetaId"), module: '情景模拟', courseUnit: '', type: 1, btnName: '41', userId: localStorage.getItem("userId") }).subscribe(function (result) {
                        console.log(result);
                    });
                    console.log(exerciseMetaId);
                    _this.commonService.sendPostMessage(0, 'isPractice' + 'Complete');
                }
            });
        });
        // this.videoShow = false;
        // document.getElementById('video').addEventListener("ended",function(){
        //
        //   that.videoShow = false;
        //
        // });
    };
    CasePracticeTeamBeginComponent.prototype.ngAfterViewInit = function () {
        this.commonService.initPage({
            'backgroundColor': 'white'
        });
    };
    CasePracticeTeamBeginComponent.prototype.onItemClick = function (i) {
        if (this.exercises[i].status != 2) {
            var link = ['case-practice-team-main', this.exercises[i].id, this.multiExerciseMetaId, this.learningPathId, this.practiceMetaId];
            if (this.type) {
                this.router.navigate(link, { queryParams: { type: 'huatek' } });
            }
            else {
                this.router.navigate(link);
            }
        }
    };
    CasePracticeTeamBeginComponent.prototype.goToReport = function () {
        var _this = this;
        // this.commonService.learningPortEventLogByCandy({'learningPathMetaId':localStorage.getItem('learningPathMetaId'),'module':'退出情景模拟1'}).then();
        this.apiService.getmultiKas(this.multiExerciseMetaId).subscribe(function (result) {
            if (result) {
                _this.apiService.ajax({
                    url: "/sr/insideapi/getlevel",
                    type: "post",
                    dataType: 'json',
                    contentType: 'application/json;charset=utf-8',
                    data: JSON.stringify(_this.getKaList(result)),
                    async: false,
                });
            }
            var link = ['case-practice-team-report', _this.multiExerciseMetaId, _this.learningPathId, _this.practiceMetaId];
            if (_this.type) {
                _this.router.navigate(link, { queryParams: { type: 'huatek' } });
                _this.commonService.sendPostMessage(2, 'isPractice' + 'Complete');
            }
            else {
                _this.router.navigate(link);
            }
        });
        var exerciseMetaId = $('#exerciseMetaId').val();
        this.apiService.learingTime({ learningPathMetaId: localStorage.getItem("learningPathMetaId"), module: '情景模拟', courseUnit: '', type: 2, btnName: '41', userId: localStorage.getItem("userId") }).subscribe(function (result) {
            console.log(result);
        });
        console.log(exerciseMetaId);
    };
    /*
    格式化KA对象方法
     report：传递一个报告对象
   */
    CasePracticeTeamBeginComponent.prototype.goToVideo = function () {
        var link = ['case-practice-team', this.learningPathId, this.practiceMetaId, 3, this.multiExerciseMetaId];
        if (this.type) {
            this.router.navigate(link, { queryParams: { type: 'huatek' } });
        }
        else {
            this.router.navigate(link);
        }
        this.videoShow = true;
    };
    CasePracticeTeamBeginComponent.prototype.getKaList = function (report) {
        var kaJson = { id: this.learningPathId, name: "打造高效团队", type: "exercise", kas: {}, exercisesId: this.practiceMetaId, questionId: null, optionId: null };
        if (report) {
            for (var i = 1; i <= 6; i++) {
                var kaItem = report["ka" + i];
                if (kaItem) {
                    //kaJson.kas.push({name:kaItem.name,value:kaItem.total});
                    kaJson.kas[kaItem.name] = kaItem.total;
                }
            }
        }
        return kaJson;
    };
    return CasePracticeTeamBeginComponent;
}());
export { CasePracticeTeamBeginComponent };



// WEBPACK FOOTER //
// ./src/app/case-practice-team-begin/case-practice-team-begin.component.ts.pre-build-optimizer.js